import { makeAutoObservable } from 'mobx'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { logger } from 'shared/lib'
import { toastStore } from 'shared/ui'
import { SmartViewsApi } from 'entities/SmartViews/api/smartViews'
import type { SmartView } from 'entities/SmartViews/model/SmartView'

type ISmartViewDeleteModalStoreConfig = {
  onDelete: (id: number) => void
}

export class SmartViewDeleteModalStore {
  private _idModal = 'smart_view_delete_modal'
  private _config: ISmartViewDeleteModalStoreConfig | null = null

  constructor() {
    makeAutoObservable(this)
  }

  setConfig = (config: ISmartViewDeleteModalStoreConfig) => {
    this._config = config
  }

  onCloseModal = () => {
    modalStore.removeModal(this._idModal)
  }

  openModal = (item: SmartView) => {
    modalStore.addModal({
      id: this._idModal,
      title: 'Delete smart view?',
      desc: 'This action cannot be undone',
      type: ModalTypeList.ALERT,
      showCloseButton: false,
      primaryAction: {
        text: 'Delete',
        onAction: async () => {
          await this.onDelete(item.id)
        },
      },
      secondaryAction: {
        text: 'Cancel',
        onAction: () => {
          this.onCloseModal()
        },
      },
    })
  }

  onDelete = async (id: number) => {
    try {
      await SmartViewsApi.deleteSmartView(id)
      this._config?.onDelete(id)

      toastStore.add({
        title: 'Smart view deleted',
        type: 'success',
      })

      this.onCloseModal()
    } catch (e) {
      logger.error(e)

      toastStore.add({
        title: 'Unknown error',
        type: 'error',
      })
    }
  }
}
